import React from 'react';
import { instructionVersionsDataChanged } from '../actions/instuctionActions';
import { connect } from 'react-redux';
import deleteSection from './DeleteSection';

function TextField ({textfield, versionIndex, dataIndex, disable, dispatch}) {
  const instructionVersionsData = (value, field) => { dispatch(instructionVersionsDataChanged(versionIndex, dataIndex, { ...textfield, [field]: value }))};

  return (
    <div>
      <textarea
        disabled={disable}
        style={{ width: "100%", height: 70 }}
        value={textfield.description}
        onChange={(event)=>{instructionVersionsData(event.target.value, "description")}}
      />
    </div>
  )
}

const mapStateToProps = ({ instructionsReducer }) => {
  return {
    versions: instructionsReducer.versions
  }
}

const mapDispatchToProps = (dispatch) => {
  return {dispatch};
}

export default connect(mapStateToProps, mapDispatchToProps)(deleteSection(TextField));
